export function extractAddress(place) {
  const address = {
    city: '',
    state: '',
    zip: '',
    country: '',
    lat: '',
    lng: '',
    street_number: '',
    route: '',
    plain() {
      return [this.street(), this.city, this.state, this.zip].filter(Boolean).join(', ');
    },
    street() {
      return `${this.street_number || ''} ${this.route || ''}`.trim();
    },
  };

  place?.address_components?.forEach((comp) => {
    const t = comp.types;
    const v = comp.long_name;
    if (t.includes('locality')) address.city = v;
    if (t.includes('administrative_area_level_1')) address.state = v;
    if (t.includes('postal_code')) address.zip = v;
    if (t.includes('country')) address.country = v;
    if (t.includes('street_number')) address.street_number = v;
    if (t.includes('route')) address.route = v;
  });

  if (place.geometry?.location) {
    address.lat = place.geometry.location.lat();
    address.lng = place.geometry.location.lng();
  }

  return address;
}
